/** sessionStorage key: subscription invite slug before Cognito Hosted UI (same tab). */
export const PENDING_SUBSCRIPTION_INVITE_SLUG_KEY =
  "pending_subscription_invite_slug";

/** Shown on Home after Hosted UI logout following invalid invite signup (Cognito). */
export const COMPANY_COGNITO_INVITE_LOGOUT_ALERT_KEY =
  "company_cognito_invite_logout_alert";

/** sessionStorage: company email invite token before Cognito Hosted UI (same tab). */
export const PENDING_COMPANY_EMAIL_INVITE_TOKEN_KEY =
  "pending_company_email_invite_token";

/** Shown on Home after 401 Account is disabled (GraphQL / company login). */
export const COMPANY_ACCOUNT_DISABLED_ALERT_KEY =
  "company_account_disabled_alert";
